import "./block-request-a-demo.scss";
import isMobile from "../../../assets/js/isMobile";

const $ = jQuery.noConflict();

function initRequestDemoBlock() {
    if (isMobile()) {
        $(".b-request-a-demo .brands").insertAfter(
            ".b-request-a-demo .content__top"
        );
        $(".b-request-a-demo .col-form").insertAfter(
            ".b-request-a-demo .content__top"
        );
        $(".b-request-a-demo .col-success").insertAfter(
            ".b-request-a-demo .content__top"
        );
    }
}

$(document).ready(function onReady() {
    initRequestDemoBlock();
});

if (window.acf) {
    window.acf.addAction("render_block_preview", initRequestDemoBlock);
}
